<template>
  <div class="page-compact">
    <crm-panel :title="'会员管理'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.projectAdd && auth.projectAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="handleAdd"
        >
        </crm-button>
        <crm-button
          v-if="auth.projectExport && auth.projectExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>

      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="searchForm" :model="searchForm" :inline="true">
          <el-form-item label="">
            <div class="select-data-picker">
              <el-select v-model="searchDateType" style="width: 160px">
                <el-option label="项目上线日期" :value="1"></el-option>
                <el-option label="导入截止日期" :value="2"></el-option>
                <el-option label="服务截止日期" :value="3"></el-option>
              </el-select>
              <el-date-picker
                value-format="yyyy-MM-dd"
                :editable="false"
                v-model="searchTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="">
            <crm-cascader
              :value="searchForm.teamIds"
              :options="projectTeams"
              placeholder="团队"
              clearable
              :props="{ multiple: true, checkStrictly: true }"
              :show-all-levels="false"
              @change="changeParentTeam"
            >
            </crm-cascader>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="searchName"
              @clear="handleSearch"
              class="input-with-select"
              clearable
            >
              <el-select v-model="searchNameType" slot="prepend">
                <el-option label="项目名称" :value="1"></el-option>
                <el-option label="客户名称" :value="2"></el-option>
                <el-option label="sourceid" :value="3"></el-option>
                <el-option label="业务员" :value="6"></el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 列表 -->
      <el-table
        :data="projectData && projectData.results"
        height="100%"
        v-loading="loading"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          fixed="left"
          label="项目名称"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleProjectDetailShow(scope)">{{
              scope.row.projectName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="customerName"
          fixed="left"
          width="250"
          label="客户名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="salesmanName"
          align="center"
          label="业务员"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="projectDetailVO.onlineDateStr"
          align="center"
          width="150"
          label="上线日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="projectDetailVO.importDeadlineStr"
          align="center"
          label="导入截止日期"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="150"
          prop="projectSourceId"
          align="center"
          label="sourceid"
        >
        </el-table-column>
        <el-table-column fixed="right" width="100" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="auth.projectUpdate && auth.projectUpdate.toggleStatus"
              @click="handleUpdate(scope)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="auth.projectDelete && auth.projectDelete.toggleStatus"
              @click="handleDelete(scope)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 合同列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="(projectData && projectData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 新增项目弹窗 -->
    <div v-if="addProjectDialogVisible">
      <add-project
        :mode="mode"
        :id="id"
        :detail="addProjectDialogObj"
        @close="handleCloseAddDialog"
        @success="handleRefreshProject"
      >
      </add-project>
    </div>

    <!-- 项目详情侧面板 -->
    <transition name="slide-fade">
      <div v-show="projectDetailVisible">
        <project-detail
          :detailId="detailId"
          @handleCloseDetail="handleCloseProjectDetail"
        >
        </project-detail>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "~config";
import { newDownloadByUrl } from "@/scripts/utils";
import AddProject from "~component/business/project/addProject.vue";
import ProjectDetail from "~component/business/project/projectDetail.vue";
import crmPanel from "@/components/base/crmPanel";
import crmButton from "@/components/base/crmButton";
import CrmCascader from "@/components/base/crmCascader";

export default {
  components: {
    AddProject,
    ProjectDetail,
    crmPanel,
    crmButton,
    CrmCascader,
  },
  data() {
    return {
      loading: false,
      searchName: "",
      searchTime: null,
      searchDateType: 1,
      searchNameType: 1,
      // 搜索表单
      searchForm: {
        teamIds: undefined,
        dateType: undefined,
      },
      searchFormList: [
        { key: 1, name: "项目名称", value: "projectName" },
        { key: 2, name: "客户名称", value: "customerName" },
        { key: 3, name: "sourceid", value: "projectSourceId" },
        { key: 4, name: "套餐名称", value: "projectPackageName" },
        { key: 5, name: "套餐编号", value: "projectPackageCode" },
        { key: 6, name: "业务员", value: "salesmanName" },
      ],
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      isExportDisabled: false,
      detailId: "",
      id: "",
      projectDetailVisible: false,
      addProjectDialogVisible: false,
      mode: "add",
      addProjectDialogObj: undefined,
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      projectData: "project/projectData",
      projectTeams: "project/projectTeams",
      userInfo: "authority/userInfo",
    }),
  },
  watch: {
    "searchForm.teamIds": {
      handler: "handleSearch",
    },
    searchTime: {
      handler: "handleSearch",
    },
    searchDateType: {
      handler(newval, oldval) {
        if (this.searchTime && this.searchTime.length > 0) {
          this.handleSearch();
        }
      },
    },
    searchNameType: {
      handler(newval, oldval) {
        const key = this.searchFormList.find((v) => v.key === oldval).value;
        delete this.searchForm[key];
      },
    },
  },
  created() {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.searchDateType = this.$route.params.searchDateType
        ? this.$route.params.searchDateType
        : 1;
      this.searchTime = this.$route.params.searchTime
        ? this.$route.params.searchTime
        : [];
    }
    // 获取团队
    this.getProjectTeams();
    // this.handleSearch();
    this.searchForm.teamIds = [this.userInfo.teamId];
  },
  methods: {
    ...mapActions({
      getProjectTeams: "project/getProjectTeams",
      getProjectList: "project/getProjectList",
      deleteProject: "project/deleteProject",
    }),
    changeParentTeam(teamInfo) {
      if (teamInfo.type && teamInfo.type === "multiple") {
        this.searchForm.teamIds = teamInfo.value;
      } else {
        this.searchForm.teamIds = teamInfo[teamInfo.length - 1];
      }
    },
    handleExport() {
      this.isExportDisabled = true;
      this.notify = this.$notify({
        iconClass: "el-icon-loading",
        title: "",
        message: "正在导出中，请稍后...",
        duration: 0,
        showClose: false,
      });
      this.handleSearch();
      const params = {
        ...this.pagenation,
        ...this.searchForm,
        ...this.searchDate,
      };
      const url = `${config.api || ""}/api/project/export`;
      newDownloadByUrl(url, "post", params).finally(() => {
        this.isExportDisabled = false;
        this.notify.close();
      });
    },
    // 合同详情
    handleProjectDetailShow(scope, tabName) {
      this.detailId = scope.row.id;
      this.projectDetailVisible = true;
    },
    handleCloseProjectDetail(isRefresh) {
      this.projectDetailVisible = false;
      if (isRefresh) {
        this.handleSearch();
      }
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;

      // dataType 必须在 startTime、endTime 有值的情况下存在
      if (this.searchTime && this.searchTime.length > 0) {
        this.searchForm.startTimeStr = this.searchTime[0];
        this.searchForm.endTimeStr = this.searchTime[1];
        this.searchForm.dateType = this.searchDateType;
      } else {
        this.searchForm.startTimeStr = "";
        this.searchForm.endTimeStr = "";
        this.searchForm.dateType = "";
      }

      // 名称查询
      const key = this.searchFormList.find((v) => v.key === this.searchNameType).value;
      this.searchForm[key] = this.searchName || "";

      this.handleGetProjectList();
    },
    // 根据条件刷新项目列表
    handleGetProjectList() {
      this.loading = true;
      this.getProjectList({
        ...this.pagenation,
        ...this.searchForm,
        $_priority: 10,
      })
        .then(() => {
          if (
            this.projectData.results.length === 0 &&
            this.projectData.pageNumber !== 1
          ) {
            // this.pagenation.pageNumber = 1;
            this.handleGetProjectList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;

      this.handleGetProjectList();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetProjectList();
    },
    handleCloseAddDialog() {
      this.addProjectDialogVisible = false;
      this.addProjectDialogObj = undefined;
      this.id = "";
    },
    handleAdd() {
      this.addProjectDialogVisible = true;
      this.mode = "add";
      this.addProjectDialogObj = undefined;
    },
    // 编辑
    handleUpdate(scope) {
      this.id = scope.row.id;
      this.mode = "update";
      this.addProjectDialogObj = scope.row;
      this.addProjectDialogVisible = true;
    },
    handleRefreshProject() {
      this.handleGetProjectList();
    },
    // 删除合同
    handleDelete(scope) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteProject({ id: scope.row.id }).then(() => {
            this.handleGetProjectList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
